import { createStore, applyMiddleware } from 'redux';
// import { createBrowserHistory } from 'history'
import { configureStore } from '@reduxjs/toolkit';
import { rootReducerLR } from '../reducers/index';
import thunk from 'redux-thunk';
export var storeLR = configureStore({
    reducer: rootReducerLR(),
    middleware: function (getDefaultMiddleware) {
        return getDefaultMiddleware({
            serializableCheck: false
        }).concat(thunk);
    }
});
export var storeLRDev = configureStore({
    reducer: rootReducerLR('development'),
    middleware: function (getDefaultMiddleware) {
        return getDefaultMiddleware({
            serializableCheck: false
        }).concat(thunk);
    }
});
//# sourceMappingURL=configureStore.js.mapimport { createStore, applyMiddleware } from 'redux';
// import { createBrowserHistory } from 'history'
import { configureStore } from '@reduxjs/toolkit';
import { rootReducerLR } from '../reducers/index';
import thunk from 'redux-thunk';
export var storeLR = configureStore({
    reducer: rootReducerLR(),
    middleware: function (getDefaultMiddleware) {
        return getDefaultMiddleware({
            serializableCheck: false
        }).concat(thunk);
    }
});
export var storeLRDev = configureStore({
    reducer: rootReducerLR('development'),
    middleware: function (getDefaultMiddleware) {
        return getDefaultMiddleware({
            serializableCheck: false
        }).concat(thunk);
    }
});
//# sourceMappingURL=configureStore.js.map